module.exports = __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/assessment_incomplete_4-1e05f2c077c0215ea8dfdf98ac9b2c48.svg";